export default function TextField({ placeholder, type, className, inline = false, onChange }) {
	return (
		<textarea
			className={'text-field py-1.5 px-3 rounded-md transition-all resize-none ' + className}
			placeholder={placeholder}
			onChange={onChange}
		/>
	);
}
